import "./index.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "@material-tailwind/react";
import { startTokenMonitor } from "./services/authService";

import { Provider, useDispatch } from "react-redux";
import store from "./redux/store";
import { fetchUserProfile } from "./redux/userSlice";
import React, { useEffect, lazy, Suspense } from "react";

// ✅ Keep essential auth screens (needed before lazy loading can work)
import LoginScreen from "./screens/auth/LoginScreen";
import CheckMailScreen from "./screens/auth/CheckMailScreen";
import RegisterScreen from "./screens/auth/RegisterScreen";
import ForgotPasswordScreen from "./screens/auth/ForgotPasswordScreen";
import ResetPasswordScreen from "./screens/auth/ResetPasswordScreen";

// ✅ Lazy load heavy screens and pages
const Workbench = lazy(() => import("./screens/workbench/Workbench"));
const Admin = lazy(() => import("./admin/Admin.jsx"));
const ProjectDetail = lazy(() => import("./pages/ProjectDetail"));
const ViewerPage = lazy(() => import("./pages/ViewerPage"));
const ModelDetail = lazy(() => import("./pages/ModelDetail"));
const SettingDevice = lazy(() => import("./pages/SettingDevice"));
const SensorManagementPage = lazy(() => import("./pages/SensorManagementPage"));

// ✅ Lazy load template pages
const Documents = lazy(() => import("./pages/TemplatePage/Documents"));
const DocumentsId = lazy(() => import("./pages/TemplatePage/DocumentsId"));
const DocHistory = lazy(() => import("./pages/TemplatePage/DocHistory"));
const Maintenance = lazy(() => import("./pages/TemplatePage/Maintenance"));
const PreventiveMaintenance = lazy(() => import("./pages/TemplatePage/PreventiveMaintenance"));
const Repair = lazy(() => import("./pages/TemplatePage/repair"));
const CalendarRepair = lazy(() => import("./pages/TemplatePage/calendarReapair"));
const Track_Repair_Status = lazy(() => import("./pages/TemplatePage/track_repair_status"));
const Calendar = lazy(() => import("./pages/TemplatePage/calendar"));
const Profile = lazy(() => import("./components/SideBar/profile.jsx"));
const Map = lazy(() => import("./pages/TemplatePage/Map"));
const ListRepair = lazy(() => import("./pages/TemplatePage/list_repair.jsx"));
const TechnicianDetail = lazy(() => import("./pages/TemplatePage/TechnicianDetail.jsx"));
const Technicianprofile = lazy(() => import("./pages/TemplatePage/TechnicianProfile.jsx"));
const Repairhistory = lazy(() => import("./pages/TemplatePage/RepairHistory.jsx"));
const Dashboard = lazy(() => import("./pages/TemplatePage/Dashboard.jsx"));
const Folder = lazy(() => import("./pages/TemplatePage/Folder.jsx"));
const DocumentTracking = lazy(() => import("./pages/TemplatePage/DocumentTracking.jsx"));

// ✅ Loading placeholder component
const LoadingPlaceholder = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontSize: "18px" }}>
    Loading...
  </div>
);

function App() {
  useEffect(() => {
    startTokenMonitor();
    // โหลด user profile ครั้งเดียวตอนเริ่มแอป เก็บไว้ใน Redux ไม่ยิงซ้ำ
    store.dispatch(fetchUserProfile());
  }, []);
  // ✅ ปิดการ preload models เพื่อเพิ่มความเร็ว
  // Models จะโหลดทีหลังเมื่อเข้า ViewerPage เท่านั้น
  // useEffect(() => {
  //   const preloadFavorites = async () => {
  //     try {
  //       const profile = await authService.getUserProfile();
  //       const favorites = await modelService.getFavoriteModels(profile.txid);
  //       const preloadTasks = favorites.map((id) =>
  //         modelService.getUrnAndTokenAndInitViewer(
  //           id, () => {}, () => {}, null, () => {}, () => {}
  //         )
  //       );
  //       await Promise.all(preloadTasks);
  //       console.log("⭐ Preloaded all favorite models.");
  //     } catch (err) {
  //       console.error("❌ Failed to preload:", err);
  //     }
  //   };
  //   preloadFavorites();
  // }, []);

  return (
    <ThemeProvider>
      <Provider store={store}>
        <Router>
          <Suspense fallback={<LoadingPlaceholder />}>
            <Routes>
              <Route path="/" element={<Navigate to="/auth/login" />} />
              <Route path="/auth/login" element={<LoginScreen />} />
              <Route path="/auth/check-mail" element={<CheckMailScreen />} />
              <Route path="/auth/register" element={<RegisterScreen />} />
              <Route path="/auth/forgot-password" element={<ForgotPasswordScreen />} />
              <Route path="/auth/reset-password" element={<ResetPasswordScreen />} />
              <Route path="/workbench" element={<Workbench />} />
              <Route path="/Admin" element={<Admin />} />
              <Route path="/Documents" element={<Documents />} />
              <Route path="/Documents/:id" element={<DocumentsId />} />
              <Route path="/DocHistory" element={<DocHistory />} />
              <Route path="/Maintenance" element={<Maintenance />} />
              <Route path="/PreventiveMaintenance" element={<PreventiveMaintenance />} />
              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/Repair" element={<Repair />} />
              <Route path="/Folder" element={<Folder />} />
              <Route path="/DocumentTracking" element={<DocumentTracking />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
              <Route path="/model-detail/:modelId" element={<ModelDetail />} />
              <Route path="/viewer/:modelId" element={<ViewerPage />} />
              <Route path="/settingDevice/:modelId" element={<SettingDevice />} />
              <Route path="/sensors/:modelId" element={<SensorManagementPage />} />
              <Route path="/sensors" element={<SensorManagementPage />} />
              <Route path="/CalendarRepair" element={<CalendarRepair />} />
              <Route path="/Track_Repair_Status" element={<Track_Repair_Status />} />
              <Route path="/Calendar" element={<Calendar />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/Map" element={<Map />} />
              <Route path="/ListRepair" element={<ListRepair />} />
              <Route path="/TechnicianDetail" element={<TechnicianDetail />} />
              <Route path="/Technicianprofile/:id" element={<Technicianprofile />} />
              <Route path="/Repairhistory" element={<Repairhistory />} />
            </Routes>
          </Suspense>
        </Router>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
/*
//<Route path="/dashboard" element={<DashboardScreen />} />

*/
